const translations = {
  "en": {
    "Account creation error": "Account creation error",
    "Already have a Connect account": "Already have a Connect account?",
    "Be 8 to 256 characters long": "Be 8 to 256 characters long",
    "Be sure to keep it safe": "Be sure to keep it safe.",
    "Be sure to keep them safe": "Be sure to keep them safe.",
    "By creating an account, you agree to Videojet's": "By creating an account, you agree to Videojet's",
    "C_AvlExport_SuccessBreadcrumb": "Success",
    "Change": "Change",
    "Company": "Company:",
    "ConfirmNewPassword": "Confirm new password",
    "Contain a lowercase letter": "Contain a lowercase letter",
    "Contain a number": "Contain a number",
    "Contain an uppercase letter": "Contain an uppercase letter",
    "Continue": "Continue",
    "Create an account": "Create an account",
    "Create my account": "Create my account",
    "Deutsch": "Deutsch",
    "Dutch": "Dutch",
    "Email address": "Email address:",
    "English": "English",
    "Error, an SSO account already exists": "Error, an SSO account already exists.",
    "Error, email or password is incorrect": "Error, email or password is incorrect.",
    "Error, please complete this field": "Error, please complete this field.",
    "Error, please correct this field": "Error, please correct this field.",
    "First Name": "First Name:",
    "Forgotten password": "Forgotten password",
    "French": "French",
    "German": "German",
    "Go to log in": "Go to log in",
    "Hello": "Hello,",
    "HomePageTitle": "Welcome to VideojetConnect™",
    "I would like to receive marketing emails": "I would like to receive marketing emails",
    "Italian": "Italian",
    "Last Name": "Last Name:",
    "Log in": "Log in",
    "Log in using your new account credentials": "Log in using your new account credentials.",
    "New email sent with a temporary password": "New email sent with a temporary password.",
    "Next": "Next",
    "No option selected": "No option selected",
    "Not a Connect customer yet": "Not a Connect customer yet?",
    "Password": "Password:",
    "Please enter the 6-digit verification code": "Please enter the 6-digit verification code that we've sent to the above email address. This code will expire in 24 hours. If you don't see it, check your junk folder.",
    "Polish": "Polish",
    "Portuguese": "Portuguese",
    "Preferred Language": "Preferred Language:",
    "PrivacyPolicy": "privacy policy",
    "Register your email address": "Register your email address",
    "Resend the code": "Resend the code",
    "Reset your password": "Reset your password",
    "Set your password": "Set your password",
    "Smarter, safer software": "Smarter, safer software to power your coding production.",
    "Spanish": "Spanish",
    "System Default": "System Default",
    "Step 1 of 2": "Step 1 of 2",
    "Step 1 of 4": "Step 1 of 4",
    "Step 2 of 2": "Step 2 of 2",
    "Step 2 of 4": "Step 2 of 4",
    "Step 3 of 4": "Step 3 of 4",
    "Step 4 of 4": "Step 4 of 4",
    "Tell us who you are": "Tell us who you are",
    "Turkish": "Turkish",
    "Verification code": "Verification code:",
    "Verification code sent to the email": "Verification code sent to the email",
    "Verify my account": "Verify my account",
    "Verify your email": "Verify your email",
    "Your organization has already set up your account using SSO": "Your organization has already set up your account using SSO. Contact your administrator for help.",
    "Your password has been reset": "Your password has been reset",
    "Your password must": "Your password must:",
    "Your user account has been created": "Your user account has been created",
    "You'll need to log back in using the new password": "You'll need to log back in using the new password",
    "An account using the supplied email address already exists": "An account using the supplied email address already exists. Would you like to log in instead?"
  },
  "de": {
    "Account creation error": "Fehler bei der Kontoerstellung",
    "Already have a Connect account": "Haben Sie bereits ein VideojetConnect-Konto?",
    "Be 8 to 256 characters long": "Das Passwort muss 8 bis 256 Zeichen lang sein",
    "Be sure to keep it safe": "Bewahren Sie es sicher auf.",
    "Be sure to keep them safe": "Bewahren Sie sie sicher auf.",
    "By creating an account, you agree to Videojet's": "Mit der Erstellung eines Kontos erklären Sie sich mit Videojet",
    "C_AvlExport_SuccessBreadcrumb": "Erfolgreich",
    "Change": "Ändern",
    "Company": "Unternehmen:",
    "ConfirmNewPassword": "Neues Passwort bestätigen",
    "Contain a lowercase letter": "Enthält einen Kleinbuchstaben",
    "Contain a number": "Enthält eine Zahl",
    "Contain an uppercase letter": "Enthält einen Großbuchstaben",
    "Continue": "Weiter",
    "Create an account": "Ein Konto erstellen",
    "Create my account": "Mein Konto erstellen",
    "Deutsch": "Deutsch",
    "Dutch": "Niederländisch",
    "Email address": "E-Mail-Adresse:",
    "English": "Englisch",
    "Error, an SSO account already exists": "Fehler, ein SSO-Konto ist bereits vorhanden.",
    "Error, email or password is incorrect": "Fehler, E-Mail-Adresse oder Passwort sind falsch.",
    "Error, please complete this field": "Fehler, bitte füllen Sie dieses Feld aus.",
    "Error, please correct this field": "Fehler, bitte korrigieren Sie dieses Feld.",
    "First Name": "Vorname:",
    "Forgotten password": "Passwort vergessen",
    "French": "Französisch",
    "German": "Deutsch",
    "Go to log in": "zur Anmeldung",
    "Hello": "Hallo,",
    "HomePageTitle": "Willkommen bei VideojetConnect™",
    "I would like to receive marketing emails": "Ich möchte Marketing-E-Mails erhalten",
    "Italian": "Italienisch",
    "Last Name": "Nachname:",
    "Log in": "Einloggen",
    "Log in using your new account credentials": "Melden Sie sich mit Ihren neuen Zugangsdaten an.",
    "New email sent with a temporary password": "Neue E-Mail mit einem temporären Passwort gesendet.",
    "Next": "Weiter",
    "No option selected": "Keine Option selektiert",
    "Not a Connect customer yet": "Noch kein VideojetConnect-Kunde?",
    "Password": "Passwort:",
    "Please enter the 6-digit verification code": "Bitte geben Sie den 6-stelligen Bestätigungscode ein, den wir an die oben angegebene E-Mail-Adresse gesendet haben. Dieser Code läuft in 24 Stunden ab. Wenn Sie sie nicht sehen, sehen Sie bitte in Ihrem Junk-Ordner nach.",
    "Polish": "Polnisch",
    "Portuguese": "Portugiesisch",
    "Preferred Language": "Bevorzugte Sprache:",
    "PrivacyPolicy": "Datenschutzerklärung",
    "Register your email address": "Registrieren Sie Ihre E-Mail-Adresse",
    "Resend the code": "Code erneut senden",
    "Reset your password": "Setzen Sie Ihr Passwort zurück",
    "Set your password": "Legen Sie Ihr Passwort",
    "Smarter, safer software": "Intelligentere, sicherere Software für Ihre Codierungsproduktion.",
    "Spanish": "Spanisch",
    "System Default": "Systemstandard",
    "Step 1 of 2": "Schritt 1 von 2",
    "Step 1 of 4": "Schritt 1 von 4",
    "Step 2 of 2": "Schritt 2 von 2",
    "Step 2 of 4": "Schritt 2 von 4",
    "Step 3 of 4": "Schritt 3 von 4",
    "Step 4 of 4": "Schritt 4 von 4",
    "Tell us who you are": "Sagen Sie uns, wer Sie sind",
    "Turkish": "Türkisch",
    "Verification code": "Bestätigungscode:",
    "Verification code sent to the email": "Bestätigungscode an die E-Mail-Adresse gesendet",
    "Verify my account": "Mein Konto bestätigen",
    "Verify your email": "E-Mail-Adresse bestätigen",
    "Your organization has already set up your account using SSO": "Ihr Unternehmen hat Ihr Konto bereits durch SSO eingerichtet. Wenden Sie sich an Ihren Administrator, um Hilfe zu erhalten.",
    "Your password has been reset": "Ihr Kennwort wurde zurückgesetzt",
    "Your password must": "Ihr Passwort muss:",
    "Your user account has been created": "Ihr Benutzerkonto wurde erstellt",
    "You'll need to log back in using the new password": "Sie müssen sich durch Eingabe des neuen Passworts erneut anmelden",
    "An account using the supplied email address already exists": "Ein Konto mit der angegebenen E-Mail-Adresse ist bereits vorhanden. Möchten Sie sich stattdessen anmelden?"
  },
  "pt": {
    "Account creation error": "Erro ao criar conta",
    "Already have a Connect account": "Já possui uma conta VideojetConnect ?",
    "Be 8 to 256 characters long": "Ter de 8 a 256 caracteres",
    "Be sure to keep it safe": "Certifique-se de mantê-lo em segurança.",
    "Be sure to keep them safe": "Certifique-se de mantê-los em segurança.",
    "By creating an account, you agree to Videojet's": "Ao criar uma conta, você concorda com os termos da Videojet",
    "C_AvlExport_SuccessBreadcrumb": "Sucesso",
    "Change": "Alterar",
    "Company": "Empresa:",
    "ConfirmNewPassword": "Confirmar nova senha",
    "Contain a lowercase letter": "Conter uma letra minúscula",
    "Contain a number": "Conter um número",
    "Contain an uppercase letter": "Conter uma letra maiúscula",
    "Continue": "Continuar",
    "Create an account": "Criar uma conta",
    "Create my account": "Criar minha conta",
    "Deutsch": "Alemão",
    "Dutch": "Holandês",
    "Email address": "Endereço de e-mail:",
    "English": "Inglês",
    "Error, an SSO account already exists": "Erro, já existe uma conta SSO.",
    "Error, email or password is incorrect": "Erro, e-mail ou senha incorretos.",
    "Error, please complete this field": "Erro, preencha este campo.",
    "Error, please correct this field": "Erro, corrija este campo.",
    "First Name": "Nome:",
    "Forgotten password": "Esqueceu a senha?",
    "French": "Francês",
    "German": "Alemão",
    "Go to log in": "Ir para o login",
    "Hello": "Olá,",
    "HomePageTitle": "Bem-vindo ao VideojetConnect™",
    "I would like to receive marketing emails": "Gostaria de receber e-mails de marketing",
    "Italian": "Italiano",
    "Last Name": "Sobrenome:",
    "Log in": "Fazer login",
    "Log in using your new account credentials": "Faça login usando suas novas credenciais de conta.",
    "New email sent with a temporary password": "Novo e-mail enviado com uma senha temporária.",
    "Next": "Próximo",
    "No option selected": "Nenhuma opção selecionada",
    "Not a Connect customer yet": "Ainda não é cliente do VideojetConnect?",
    "Password": "Senha:",
    "Please enter the 6-digit verification code": "Digite o código de verificação de 6 dígitos que enviamos para o endereço de e-mail acima. Este código expirará em 24 horas. Se não o encontrar, verifique sua pasta de lixo eletrônico.",
    "Polish": "Polonês",
    "Portuguese": "Português",
    "Preferred Language": "Idioma preferido:",
    "PrivacyPolicy": "política de privacidade",
    "Register your email address": "Registre seu endereço de e-mail",
    "Resend the code": "Reenvie o código",
    "Reset your password": "Redefina sua senha",
    "Set your password": "Defina sua senha",
    "Smarter, safer software": "Software mais inteligente e seguro para impulsionar sua produção de codificação.",
    "Spanish": "Espanhol",
    "System Default": "Padrão do Sistema",
    "Step 1 of 2": "Etapa 1 de 2",
    "Step 1 of 4": "Etapa 1 de 4",
    "Step 2 of 2": "Etapa 2 de 2",
    "Step 2 of 4": "Etapa 2 de 4",
    "Step 3 of 4": "Etapa 3 de 4",
    "Step 4 of 4": "Etapa 4 de 4",
    "Tell us who you are": "Diga-nos quem você é",
    "Turkish": "Turco",
    "Verification code": "Código de verificação:",
    "Verification code sent to the email": "Código de verificação enviado para o e-mail",
    "Verify my account": "Verificar minha conta",
    "Verify your email": "Verificar seu e-mail",
    "Your organization has already set up your account using SSO": "Sua organização já configurou sua conta usando SSO. Entre em contato com seu administrador para obter ajuda.",
    "Your password has been reset": "Sua senha foi redefinida",
    "Your password must": "Sua senha deve:",
    "Your user account has been created": "Sua conta de usuário foi criada",
    "You'll need to log back in using the new password": "Você precisará fazer login novamente usando a nova senha",
    "An account using the supplied email address already exists": "Já existe uma conta usando o endereço de e-mail fornecido. Deseja fazer login em vez disso?"
  },
  "fr": {
    "Account creation error": "Erreur de création de compte",
    "Already have a Connect account": "Vous avez déjà un compte VideojetConnect ?",
    "Be 8 to 256 characters long": "Le mot de passe doit comporter entre 8 et 256 caractères",
    "Be sure to keep it safe": "Assurez-vous de le conserver en sécurité.",
    "Be sure to keep them safe": "Assurez-vous de les conserver en sécurité.",
    "By creating an account, you agree to Videojet's": "En créant le compte, vous êtes d'accord avec Videojet's",
    "C_AvlExport_SuccessBreadcrumb": "Succès",
    "Change": "Variation",
    "Company": "Entreprise :",
    "ConfirmNewPassword": "Confirmez le nouveau mot de passe",
    "Contain a lowercase letter": "Contient une lettre minuscule",
    "Contain a number": "Contient un nombre",
    "Contain an uppercase letter": "Contient une lettre majuscule",
    "Continue": "Continuer",
    "Create an account": "Créer un compte",
    "Create my account": "Créer mon compte",
    "Deutsch": "Allemand",
    "Dutch": "Néerlandais",
    "Email address": "Adresse de courrier électronique :",
    "English": "Anglais",
    "Error, an SSO account already exists": "Erreur, un compte SSO existe déjà.",
    "Error, email or password is incorrect": "Erreur, l'email ou mot de passe est incorrect.",
    "Error, please complete this field": "Erreur, veuillez renseigner ce champ.",
    "Error, please correct this field": "Erreur, veuillez corriger ce champ.",
    "First Name": "Prénom :",
    "Forgotten password": "Mot de passe oublié",
    "French": "Français",
    "German": "Allemand",
    "Go to log in": "Pour se connecter",
    "Hello": "Bonjour,",
    "HomePageTitle": "Bienvenue sur VideojetConnect™",
    "I would like to receive marketing emails": "J'aimerais recevoir des e-mails de marketing",
    "Italian": "Italien",
    "Last Name": "Nom de famille :",
    "Log in": "Connexion",
    "Log in using your new account credentials": "Connectez-vous à l'aide de vos nouveaux identifiants de compte.",
    "New email sent with a temporary password": "Nouvel e-mail envoyé avec le mot de passe temporaire.",
    "Next": "Suivant",
    "No option selected": "Aucune option sélectionnée",
    "Not a Connect customer yet": "Pas encore client de VideojetConnect ?",
    "Password": "Mot de passe :",
    "Please enter the 6-digit verification code": "Veuillez saisir le code de vérification à 6 chiffres que nous avons envoyé à l'adresse e-mail ci-dessus. Ce code expire dans 24 heures. Si vous ne le voyez pas, vérifiez votre dossier de spam.",
    "Polish": "Polonais",
    "Portuguese": "Portugais",
    "Preferred Language": "Langue préférée :",
    "PrivacyPolicy": "politique de confidentialité",
    "Register your email address": "Saisissez votre adresse e-mail",
    "Resend the code": "Renvoyer le code",
    "Reset your password": "Réinitialisez votre mot de passe",
    "Set your password": "Définissez votre mot de passe",
    "Smarter, safer software": "Logiciel plus intelligent, plus sécurisé pour alimenter votre production de codes.",
    "Spanish": "Espagnol",
    "System Default": "Valeur par défaut système",
    "Step 1 of 2": "Étape 1 sur 2",
    "Step 1 of 4": "Étape 1 sur 4",
    "Step 2 of 2": "Étape 2 sur 2",
    "Step 2 of 4": "Étape 2 sur 4",
    "Step 3 of 4": "Étape 3 sur 4",
    "Step 4 of 4": "Étape 4 sur 4",
    "Tell us who you are": "Dites-nous qui vous êtes",
    "Turkish": "Turc",
    "Verification code": "Code de vérification :",
    "Verification code sent to the email": "Code de vérification envoyé à l'adresse e-mail",
    "Verify my account": "Vérifier mon compte",
    "Verify your email": "Vérifier votre adresse e-mail",
    "Your organization has already set up your account using SSO": "Votre organisation a déjà défini un compte à l'aide de SSO. Contactez votre administrateur pour de l'aide.",
    "Your password has been reset": "Votre mot de passe a été réinitialisé",
    "Your password must": "Votre mot de passe doit :",
    "Your user account has been created": "Votre compte utilisateur a été créé",
    "You'll need to log back in using the new password": "Vous devez vous reconnecter à l'aide de votre nouveau mot de passe",
    "An account using the supplied email address already exists": "Il existe déjà un compte utilisant l'adresse e-mail fournie. Désirez-vous plutôt vous connecter ?"
  },
  "it": {
    "Account creation error": "Errore creazione account",
    "Already have a Connect account": "Hai già un account VideojetConnect?",
    "Be 8 to 256 characters long": "Lunghezza caratteri da 8 a 256",
    "Be sure to keep it safe": "Assicuratevi di tenerlo al sicuro.",
    "Be sure to keep them safe": "Assicuratevi di tenerli al sicuro.",
    "By creating an account, you agree to Videojet's": "Creando un account, accetti le condizioni di Videojet",
    "C_AvlExport_SuccessBreadcrumb": "Riuscito",
    "Change": "Modifica",
    "Company": "Società:",
    "ConfirmNewPassword": "Conferma la nuova password",
    "Contain a lowercase letter": "Contiene una lettera minuscola",
    "Contain a number": "Contiene un numero",
    "Contain an uppercase letter": "Contiene una lettera maiuscola",
    "Continue": "Continua",
    "Create an account": "Crea un account",
    "Create my account": "Crea il mio account",
    "Deutsch": "Tedesco",
    "Dutch": "Olandese",
    "Email address": "Indirizzo e-mail:",
    "English": "Inglese",
    "Error, an SSO account already exists": "Errore, esiste già un account SSO.",
    "Error, email or password is incorrect": "Errore, e-mail o password errate.",
    "Error, please complete this field": "Errore, completa questo campo.",
    "Error, please correct this field": "Errore, correggi questo campo.",
    "First Name": "Nome:",
    "Forgotten password": "Password dimenticata",
    "French": "Francese",
    "German": "Tedesco",
    "Go to log in": "Vai al login",
    "Hello": "Salve,",
    "HomePageTitle": "Benvenuto a VideojetConnect™",
    "I would like to receive marketing emails": "Vorrei ricevere e-mail di marketing",
    "Italian": "Italiano",
    "Last Name": "Cognome:",
    "Log in": "Accedi",
    "Log in using your new account credentials": "Accedi con le nuove credenziali del tuo account.",
    "New email sent with a temporary password": "È stata inviata una e-mail con una password temporanea.",
    "Next": "Avanti",
    "No option selected": "Nessuna opzione selezionata",
    "Not a Connect customer yet": "Non sei ancora un cliente VideojetConnect?",
    "Password": "Password:",
    "Please enter the 6-digit verification code": "Inserisci il codice di verifica a 6 cifre che ti abbiamo inviato all'indirizzo e-mail sopra. Il codice scadrà fra 24 ore. Se non lo vedi, controlla la tua cartella di Posta indesiderata.",
    "Polish": "Polacco",
    "Portuguese": "Portoghese",
    "Preferred Language": "Lingua preferita:",
    "PrivacyPolicy": "Rispetto della privacy",
    "Register your email address": "Inserisci il tuo indirizzo di posta elettronica",
    "Resend the code": "Invia di nuovo il codice",
    "Reset your password": "Reimposta password",
    "Set your password": "Imposta la password",
    "Smarter, safer software": "Software più intelligente e sicuro per alimentare la tua produzione di codifica.",
    "Spanish": "Spagnolo",
    "System Default": "Default di sistema",
    "Step 1 of 2": "Passaggio 1 di 2",
    "Step 1 of 4": "Passaggio 1 di 4",
    "Step 2 of 2": "Passaggio 2 di 2",
    "Step 2 of 4": "Passaggio 2 di 4",
    "Step 3 of 4": "Passaggio 3 di 4",
    "Step 4 of 4": "Passaggio 4 di 4",
    "Tell us who you are": "Dicci di chi sei",
    "Turkish": "Turco",
    "Verification code": "Codice di verifica:",
    "Verification code sent to the email": "Codice di verifica inviato all'indirizzo e-mail",
    "Verify my account": "Verifica il mio account",
    "Verify your email": "Verifica la tua e-mail",
    "Your organization has already set up your account using SSO": "La tua Società ha già configurato il tuo account utilizzando il SSO. Contatta l'amministratore per avere supporto.",
    "Your password has been reset": "La tua password è stata reimpostata",
    "Your password must": "La tua password deve:",
    "Your user account has been created": "Il tuo account utente è stato creato",
    "You'll need to log back in using the new password": "Devi accedere nuovamente con la nuova password",
    "An account using the supplied email address already exists": "Esiste già un account con questa e-mail. Vuoi accedere invece?"
  },
  "nl": {
    "Account creation error": "Fout aanmaak account",
    "Already have a Connect account": "Hebt u al een VideojetConnect-account?",
    "Be 8 to 256 characters long": "Moet 8 tot 256 tekens lang zijn",
    "Be sure to keep it safe": "Zorg dat u het veilig bewaart.",
    "Be sure to keep them safe": "Zorg dat u ze veilig bewaart.",
    "By creating an account, you agree to Videojet's": "Door een account aan te maken, gaat u akkoord met Videojet's",
    "C_AvlExport_SuccessBreadcrumb": "Geslaagd",
    "Change": "Veranderen",
    "Company": "Bedrijf:",
    "ConfirmNewPassword": "Nieuw wachtwoord bevestigen",
    "Contain a lowercase letter": "Bevat een kleine letter",
    "Contain a number": "Bevat een nummer",
    "Contain an uppercase letter": "Bevat een hoofdletter",
    "Continue": "Doorgaan",
    "Create an account": "Een account aanmaken",
    "Create my account": "Mijn account aanmaken",
    "Deutsch": "Deutsch",
    "Dutch": "Nederlands",
    "Email address": "E-mailadres:",
    "English": "Engels",
    "Error, an SSO account already exists": "Fout, er bestaat al een SSO-account.",
    "Error, email or password is incorrect": "Fout, e-mail of wachtwoord is onjuist.",
    "Error, please complete this field": "Fout, vul dit veld in.",
    "Error, please correct this field": "Fout, corrigeer dit veld.",
    "First Name": "Voornaam:",
    "Forgotten password": "Wachtwoord vergeten",
    "French": "Frans",
    "German": "Duits",
    "Go to log in": "Aanmelden",
    "Hello": "Hallo,",
    "HomePageTitle": "Welkom bij VideojetConnect™",
    "I would like to receive marketing emails": "Ik ontvang graag marketinge-mails",
    "Italian": "Italiaans",
    "Last Name": "Achternaam:",
    "Log in": "Meld u aan",
    "Log in using your new account credentials": "Meld u aan met uw nieuwe account-referenties.",
    "New email sent with a temporary password": "Er is een nieuwe e-mail verzonden met een tijdelijk wachtwoord.",
    "Next": "Volgende",
    "No option selected": "Geen optie geselecteerd",
    "Not a Connect customer yet": "Bent u nog niet een VideojetConnect-klant?",
    "Password": "Wachtwoord:",
    "Please enter the 6-digit verification code": "Voer de 6-cijferige verificatiecode in dat we naar het bovenstaande e-mailadres hebben gestuurd. Deze code zal over 24 uur verlopen. Als u hem niet ziet, controleer dan uw spammap.",
    "Polish": "Pools",
    "Portuguese": "Portugees",
    "Preferred Language": "Voorkeurstaal:",
    "PrivacyPolicy": "privacybeleid",
    "Register your email address": "Uw e-mailadres registreren",
    "Resend the code": "De code opnieuw sturen",
    "Reset your password": "Uw wachtwoord resetten",
    "Set your password": "Uw wachtwoord instellen",
    "Smarter, safer software": "Slimmere, veiligere software voor uw codeerproductie.",
    "Spanish": "Spaans",
    "System Default": "Systeemstandaard",
    "Step 1 of 2": "Stap 1 van 2",
    "Step 1 of 4": "Stap 1 van 4",
    "Step 2 of 2": "Stap 2 van 2",
    "Step 2 of 4": "Stap 2 van 4",
    "Step 3 of 4": "Stap 3 van 4",
    "Step 4 of 4": "Stap 4 van 4",
    "Tell us who you are": "Vertel ons wie u bent",
    "Turkish": "Turks",
    "Verification code": "Verificatiecode:",
    "Verification code sent to the email": "Verificatiecode verzonden naar de e-mail",
    "Verify my account": "Mijn account verifiëren",
    "Verify your email": "Uw e-mail verifiëren",
    "Your organization has already set up your account using SSO": "Uw organisatie heeft uw account al opgesteld met gebruik van SSO. Neem contact op met uw beheerder voor hulp.",
    "Your password has been reset": "Uw wachtwoord is gereset",
    "Your password must": "Uw wachtwoord moet:",
    "Your user account has been created": "Uw gebruikersaccount is aangemaakt",
    "You'll need to log back in using the new password": "U moet zich opnieuw aanmelden met gebruik van het nieuwe wachtwoord",
    "An account using the supplied email address already exists": "Er bestaat al een account met het gegeven e-mailadres. Wilt u zich in plaats daarvan aanmelden?"
  },
  "es": {
    "Account creation error": "Error de creación de cuenta",
    "Already have a Connect account": "¿Ya tiene una cuenta de VideojetConnect?",
    "Be 8 to 256 characters long": "Extensión de 8 a 256 caracteres",
    "Be sure to keep it safe": "Asegúrese de mantenerla en un lugar seguro.",
    "Be sure to keep them safe": "Asegúrese de mantenerlas en un lugar seguro.",
    "By creating an account, you agree to Videojet's": "Al crear una cuenta, acepta Videojet",
    "C_AvlExport_SuccessBreadcrumb": "Logro",
    "Change": "Cambiar",
    "Company": "Compañía:",
    "ConfirmNewPassword": "Confirmar nueva contraseña",
    "Contain a lowercase letter": "Debe contener una letra minúscula",
    "Contain a number": "Debe contener un número",
    "Contain an uppercase letter": "Debe contener una letra mayúscula",
    "Continue": "Continuar",
    "Create an account": "Crear una cuenta",
    "Create my account": "Crear mi cuenta",
    "Deutsch": "Alemán",
    "Dutch": "Holandés",
    "Email address": "Dirección de correo electrónico:",
    "English": "Inglés",
    "Error, an SSO account already exists": "Error, ya existe una cuenta SSO.",
    "Error, email or password is incorrect": "Error, el correo electrónico o la contraseña son incorrectos.",
    "Error, please complete this field": "Error, complete este campo.",
    "Error, please correct this field": "Error, corrija este campo.",
    "First Name": "Nombre:",
    "Forgotten password": "¿Olvidó su contraseña?",
    "French": "Francés",
    "German": "Alemán",
    "Go to log in": "Ir a iniciar sesión",
    "Hello": "Hola,",
    "HomePageTitle": "Bienvenido a VideojetConnect™",
    "I would like to receive marketing emails": "Me gustaría recibir correos promocionales",
    "Italian": "Italiano",
    "Last Name": "Apellido:",
    "Log in": "Iniciar sesión",
    "Log in using your new account credentials": "Inicie sesión con las credenciales de su cuenta nueva.",
    "New email sent with a temporary password": "Nuevo correo electrónico enviado con una contraseña temporal.",
    "Next": "Siguiente",
    "No option selected": "No se seleccionó ninguna opción",
    "Not a Connect customer yet": "¿No es un cliente de VideojetConnect aún?",
    "Password": "Contraseña:",
    "Please enter the 6-digit verification code": "Ingrese el código de verificación de 6 dígitos que le enviamos a la dirección de correo electrónico indicada anteriormente. Este código caducará en 24 horas. Si no lo ve, revise su carpeta de correo no deseado.",
    "Polish": "Polaco",
    "Portuguese": "Portugués",
    "Preferred Language": "Idioma de preferencia:",
    "PrivacyPolicy": "Política de privacidad",
    "Register your email address": "Registre su dirección de correo electrónico",
    "Resend the code": "Reenviar el código",
    "Reset your password": "Restablecer su contraseña",
    "Set your password": "Configure su contraseña",
    "Smarter, safer software": "Software más inteligente y seguro para potenciar su producción de codificación.",
    "Spanish": "Español",
    "System Default": "Valor predeterminado del sistema",
    "Step 1 of 2": "Paso 1 de 2",
    "Step 1 of 4": "Paso 1 de 4",
    "Step 2 of 2": "Paso 2 de 2",
    "Step 2 of 4": "Paso 2 de 4",
    "Step 3 of 4": "Paso 3 de 4",
    "Step 4 of 4": "Paso 4 de 4",
    "Tell us who you are": "Díganos quién es",
    "Turkish": "Turco",
    "Verification code": "Código de verificación:",
    "Verification code sent to the email": "Código de verificación enviado al correo",
    "Verify my account": "Verificar mi cuenta",
    "Verify your email": "Verificar su correo",
    "Your organization has already set up your account using SSO": "Su organización ya ha configurado su cuenta usando SSO. Comuníquese con su administrador para obtener ayuda.",
    "Your password has been reset": "Se ha restablecido su contraseña",
    "Your password must": "Su contraseña debe:",
    "Your user account has been created": "Se ha creado su cuenta de usuario",
    "You'll need to log back in using the new password": "Deberá volver a iniciar sesión con la nueva contraseña",
    "An account using the supplied email address already exists": "Ya existe una cuenta con la dirección de correo electrónico proporcionada. ¿Prefiere iniciar sesión en su lugar?"
  },
  "tr": {
    "Account creation error": "Hesap oluşturma hatası",
    "Already have a Connect account": "Zaten bir VideojetConnect hesabınız var mı?",
    "Be 8 to 256 characters long": "8 ila 256 karakter uzunluğunda olmalıdır",
    "Be sure to keep it safe": "Bunu güvenli bir şekilde saklamaya dikkat edin.",
    "Be sure to keep them safe": "Bunları güvenli bir şekilde saklamaya dikkat edin.",
    "By creating an account, you agree to Videojet's": "Bir hesap oluşturmakla, Videojet'in şunları yapmasını kabul etmiş olursunuz",
    "C_AvlExport_SuccessBreadcrumb": "Başarı",
    "Change": "Değiştir",
    "Company": "Şirket:",
    "ConfirmNewPassword": "Yeni parolayı onayla",
    "Contain a lowercase letter": "Bir küçük harf içermelidir",
    "Contain a number": "Bir sayı içermelidir",
    "Contain an uppercase letter": "Bir büyük harf içermelidir",
    "Continue": "Devam et",
    "Create an account": "Bir hesap oluştur",
    "Create my account": "Hesabımı oluştur",
    "Deutsch": "Almanca",
    "Dutch": "Flemenkçe",
    "Email address": "E-posta adresi:",
    "English": "İngilizce",
    "Error, an SSO account already exists": "Hata, bir SSO hesabı zaten mevcut.",
    "Error, email or password is incorrect": "Hata, e-posta veya parola yanlış.",
    "Error, please complete this field": "Hata, lütfen bu alanı doldurun.",
    "Error, please correct this field": "Hata, lütfen bu alanı düzeltin.",
    "First Name": "Adı:",
    "Forgotten password": "Unutulan parola",
    "French": "Fransızca",
    "German": "Almanca",
    "Go to log in": "Oturum açmaya git",
    "Hello": "Merhaba,",
    "HomePageTitle": "VideojetConnect™'e Hoş Geldiniz",
    "I would like to receive marketing emails": "Pazarlama e-postaları almak istiyorum",
    "Italian": "İtalyanca",
    "Last Name": "Soyadı:",
    "Log in": "Oturum aç",
    "Log in using your new account credentials": "Yeni hesap bilgilerinizi kullanarak oturum açın.",
    "New email sent with a temporary password": "Yeni e-posta geçici bir parolayla gönderildi.",
    "Next": "Sonraki",
    "No option selected": "Seçili seçenek yok",
    "Not a Connect customer yet": "Henüz bir VideojetConnect müşterisi değil misiniz?",
    "Password": "Şifre:",
    "Please enter the 6-digit verification code": "Lütfen yukarıdaki e-posta adresine gönderdiğimiz 6 haneli doğrulama kodunu girin. Bu kodun geçerliliği 24 saat içinde sona erecek. Kodu göremiyorsanız, istenmeyen posta klasörüne bakın.",
    "Polish": "Lehçe",
    "Portuguese": "Portekizce",
    "Preferred Language": "Tercih Edilen Dil:",
    "PrivacyPolicy": "gizlilik politikasını kabul etmiş olursunuz",
    "Register your email address": "E-posta adresinizi kaydettirin",
    "Resend the code": "Kodu tekrar gönder",
    "Reset your password": "Parolanızı sıfırlayın",
    "Set your password": "Parolanızı belirleyin",
    "Smarter, safer software": "Kodlama üretiminizi güçlendirecek daha akıllı, daha güvenli yazılım.",
    "Spanish": "İspanyolca",
    "System Default": "Sistem Varsayılanı",
    "Step 1 of 2": "Adım 1 / 2",
    "Step 1 of 4": "Adım 1 / 4",
    "Step 2 of 2": "Adım 2 / 2",
    "Step 2 of 4": "Adım 2 / 4",
    "Step 3 of 4": "Adım 3 / 4",
    "Step 4 of 4": "Adım 4 / 4",
    "Tell us who you are": "Bize kim olduğunuzu söyleyin",
    "Turkish": "Türkçe",
    "Verification code": "Doğrulama kodu:",
    "Verification code sent to the email": "Doğrulama kodu e-posta adresine gönderildi",
    "Verify my account": "Hesabımı doğrula",
    "Verify your email": "E-postanızı doğrulayın",
    "Your organization has already set up your account using SSO": "Kuruluşunuz SSO kullanarak hesabınızı zaten oluşturmuş. Yardım için yöneticinizle iletişime geçin.",
    "Your password has been reset": "Parolanız sıfırlandı",
    "Your password must": "Parolanız şu şekilde olmalıdır:",
    "Your user account has been created": "Kullanıcı hesabınız oluşturuldu",
    "You'll need to log back in using the new password": "Yeni parolayı kullanarak yeniden oturum açmanız gerekecektir",
    "An account using the supplied email address already exists": "Verilen e-posta adresini kullanan bir hesap zaten mevcut. Bunun yerine giriş yapmak ister misiniz?"
  },
  "pl": {
    "Account creation error": "Błąd podczas tworzenia konta",
    "Already have a Connect account": "Masz już konto VideojetConnect ?",
    "Be 8 to 256 characters long": "Długość 8 - 256 znaków",
    "Be sure to keep it safe": "Pamiętaj, aby było bezpieczne.",
    "Be sure to keep them safe": "Pamiętaj, aby je zabezpieczyć.",
    "By creating an account, you agree to Videojet's": "Poprzez utworzenie konta, zgadzasz się na Videojet",
    "C_AvlExport_SuccessBreadcrumb": "Udało się",
    "Change": "Zmień",
    "Company": "Firma:",
    "ConfirmNewPassword": "Potwierdź nowe hasło",
    "Contain a lowercase letter": "Zawiera małą literę",
    "Contain a number": "Zawiera cyfrę",
    "Contain an uppercase letter": "Zawiera dużą literę",
    "Continue": "Kontynuuj",
    "Create an account": "Utwórz konto",
    "Create my account": "Utwórz moje konto",
    "Deutsch": "Deutsch",
    "Dutch": "Holenderski",
    "Email address": "Adres e-mail:",
    "English": "Angielski",
    "Error, an SSO account already exists": "Błąd, Konto SSO już istnieje.",
    "Error, email or password is incorrect": "Błąd, email lub hasło są nieprawidłowe.",
    "Error, please complete this field": "Błąd, wypełnij to pole.",
    "Error, please correct this field": "Błąd, popraw to pole.",
    "First Name": "Imię:",
    "Forgotten password": "Zapomniane hasło",
    "French": "Francuski",
    "German": "Niemiecki",
    "Go to log in": "Przejdź do logowania",
    "Hello": "Dzień dobry,",
    "HomePageTitle": "Witamy w VideojetConnect™",
    "I would like to receive marketing emails": "Chciałbym otrzymywać emaile marketingowe",
    "Italian": "Włoski",
    "Last Name": "Nazwisko:",
    "Log in": "Zaloguj się",
    "Log in using your new account credentials": "Zaloguj się, korzystając z nowych danych konta.",
    "New email sent with a temporary password": "Wysłano nową wiadomość email z tymczasowym hasłem.",
    "Next": "Następny",
    "No option selected": "Nie wybrano żadnych opcji",
    "Not a Connect customer yet": "Nie jesteś jeszcze klientem VideojetConnect?",
    "Password": "Hasło:",
    "Please enter the 6-digit verification code": "Wprowadź 6-cyfrowy kod weryfikacyjny, który wysłaliśmy na powyższy adres email. Kod wygaśnie za 24 godziny. Jeżeli go nie widzisz, sprawdź folder śmieci.",
    "Polish": "Polski",
    "Portuguese": "Portugalski",
    "Preferred Language": "Preferowany język:",
    "PrivacyPolicy": "Polityka prywatności",
    "Register your email address": "Zarejestruj swój adres e-mail",
    "Resend the code": "Wyślij ponownie kod",
    "Reset your password": "Zresetuj hasło",
    "Set your password": "Ustaw hasło",
    "Smarter, safer software": "Inteligentniejsze, bezpieczniejsze oprogramowanie do wspierania produkcji kodowania.",
    "Spanish": "Hiszpański",
    "System Default": "Domyślny system",
    "Step 1 of 2": "Krok 1 z 2",
    "Step 1 of 4": "Krok 1 z 4",
    "Step 2 of 2": "Krok 2 z 2",
    "Step 2 of 4": "Krok 2 z 4",
    "Step 3 of 4": "Krok 3 z 4",
    "Step 4 of 4": "Krok 4 z 4",
    "Tell us who you are": "Powiedz nam kim jesteś",
    "Turkish": "Turecki",
    "Verification code": "Kod weryfikacyjny:",
    "Verification code sent to the email": "Kod weryfikacyjny wysłany na adres e-mail",
    "Verify my account": "Sprawdź konto",
    "Verify your email": "Sprawdź e-mail",
    "Your organization has already set up your account using SSO": "Twoja organizacja już skonfigurowała Twoje konto za pomocą SSO. Skontaktuj się z administratorem w celu uzyskania pomocy.",
    "Your password has been reset": "Twoje hasło zostało zresetowane",
    "Your password must": "Twoje hasło musi:",
    "Your user account has been created": "Twoje konto użytkownika zostało utworzone",
    "You'll need to log back in using the new password": "Musisz się ponownie zalogować, korzystając z nowego hasła",
    "An account using the supplied email address already exists": "Konto wykorzystujące podany adres email już istnieje. Chcesz się zalogować?"
  }
};

export default translations;